//          __  _ __
//   __  __/ /_(_) /____
//  / / / / __/ / / ___/
// / /_/ / /_/ / (__  )
// \__,_/\__/_/_/____/

/* global */

import anime from 'animejs/lib/anime.es.js';

function scrollToHref( anchor, anchorOffset ) {

  return new Promise( (resolve) => {

    const offset = 'undefined' === typeof anchor || '#' === anchor ? 0 : $( anchor ).offset();
    const scrollTop = $( window ).scrollTop();
    const scrollSpeed = 1;
    const headerHeight = 72; // taken from navbar-height in bootstrap_variables.scss

    // Set default value if none given
    anchorOffset = 'undefined' === typeof anchorOffset ? 0 : anchorOffset;

    // console.groupCollapsed( '{ scrollToHref }' );
    // console.log( 'anchor: %o', anchor );
    // console.log( 'anchorOffset: %o', anchorOffset );
    // console.log( 'offset: %o', offset );
    // console.log( 'scrollTop: ' + scrollTop );
    // console.log( 'anchorOffset: %o', anchorOffset );
    // console.groupEnd();

    anime( {
      targets: 'html,body',
      scrollTop: 'undefined' === typeof offset ? 0 : offset.top - anchorOffset - headerHeight,
      delay: 0,
      easing: 'easeOutCubic',
      duration: 'undefined' === typeof offset ? scrollTop * scrollSpeed : Math.abs( scrollTop - offset.top - anchorOffset ) * scrollSpeed,
      complete: () => {
        return resolve()
      }
    } );
  } )

}

export { scrollToHref };



// WEBPACK FOOTER //
// ./scripts/util/scrolltohref.js